import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragableSixDots = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 4.0013C4.63246 4.0013 4.33398 3.70283 4.33398 3.33464C4.33398 2.96645 4.63246 2.66797 5.00065 2.66797C5.36884 2.66797 5.66732 2.96645 5.66732 3.33464C5.66732 3.70283 5.36884 4.0013 5.00065 4.0013Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 8.66797C4.63246 8.66797 4.33398 8.36949 4.33398 8.0013C4.33398 7.63311 4.63246 7.33464 5.00065 7.33464C5.36884 7.33464 5.66732 7.63311 5.66732 8.0013C5.66732 8.36949 5.36884 8.66797 5.00065 8.66797Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 13.3346C4.63246 13.3346 4.33398 13.0362 4.33398 12.668C4.33398 12.2998 4.63246 12.0013 5.00065 12.0013C5.36884 12.0013 5.66732 12.2998 5.66732 12.668C5.66732 13.0362 5.36884 13.3346 5.00065 13.3346Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 4.0013C10.6325 4.0013 10.334 3.70283 10.334 3.33464C10.334 2.96645 10.6325 2.66797 11.0007 2.66797C11.3688 2.66797 11.6673 2.96645 11.6673 3.33464C11.6673 3.70283 11.3688 4.0013 11.0007 4.0013Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 8.66797C10.6325 8.66797 10.334 8.36949 10.334 8.0013C10.334 7.63311 10.6325 7.33464 11.0007 7.33464C11.3688 7.33464 11.6673 7.63311 11.6673 8.0013C11.6673 8.36949 11.3688 8.66797 11.0007 8.66797Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 13.3346C10.6325 13.3346 10.334 13.0362 10.334 12.668C10.334 12.2998 10.6325 12.0013 11.0007 12.0013C11.3688 12.0013 11.6673 12.2998 11.6673 12.668C11.6673 13.0362 11.3688 13.3346 11.0007 13.3346Z",
			fill: "#D4D4D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 4.0013C4.63246 4.0013 4.33398 3.70283 4.33398 3.33464C4.33398 2.96645 4.63246 2.66797 5.00065 2.66797C5.36884 2.66797 5.66732 2.96645 5.66732 3.33464C5.66732 3.70283 5.36884 4.0013 5.00065 4.0013Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 8.66797C4.63246 8.66797 4.33398 8.36949 4.33398 8.0013C4.33398 7.63311 4.63246 7.33464 5.00065 7.33464C5.36884 7.33464 5.66732 7.63311 5.66732 8.0013C5.66732 8.36949 5.36884 8.66797 5.00065 8.66797Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00065 13.3346C4.63246 13.3346 4.33398 13.0362 4.33398 12.668C4.33398 12.2998 4.63246 12.0013 5.00065 12.0013C5.36884 12.0013 5.66732 12.2998 5.66732 12.668C5.66732 13.0362 5.36884 13.3346 5.00065 13.3346Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 4.0013C10.6325 4.0013 10.334 3.70283 10.334 3.33464C10.334 2.96645 10.6325 2.66797 11.0007 2.66797C11.3688 2.66797 11.6673 2.96645 11.6673 3.33464C11.6673 3.70283 11.3688 4.0013 11.0007 4.0013Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 8.66797C10.6325 8.66797 10.334 8.36949 10.334 8.0013C10.334 7.63311 10.6325 7.33464 11.0007 7.33464C11.3688 7.33464 11.6673 7.63311 11.6673 8.0013C11.6673 8.36949 11.3688 8.66797 11.0007 8.66797Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0007 13.3346C10.6325 13.3346 10.334 13.0362 10.334 12.668C10.334 12.2998 10.6325 12.0013 11.0007 12.0013C11.3688 12.0013 11.6673 12.2998 11.6673 12.668C11.6673 13.0362 11.3688 13.3346 11.0007 13.3346Z",
			stroke: "#D4D4D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDragableSixDots);
export default ForwardRef;
